import React from 'react';

const YearMonthSelector = ({ selectedYear, setSelectedYear, selectedMonth, setSelectedMonth }) => {
  const startYear = 2025;
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  const monthOrder = [
    'April', 'May', 'June', 'July', 'August', 'September',
    'October', 'November', 'December', 'January', 'February', 'March'
  ];

  return (
    <div className="dr-box">
      <p>Year & Month</p>

      <select className="form-select" value={selectedYear} onChange={(e) => setSelectedYear(parseInt(e.target.value))}>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>

      <select
        className="form-select select-width ms-2" style={{width:"110px"}} value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
        {monthOrder.map((month) => (
          <option key={month} value={month}>
            {month}
          </option>
        ))}
      </select>
    </div>
  );
};


export default YearMonthSelector;
